import Vue from 'vue';
import Vuex from 'vuex';
import impersonateStore from '@/store-modules/console/impersonate-user';
import tenantStore from '@/store-modules/tenant-settings';
import rosterStore from '@/store-modules/roster/roster';
import categorySubjectStore from '@/store-modules/category-subject/category-subject';
import partnerDataStore from '@/store-modules/partner-data/partner-data';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {

  },
  actions: {

  },
  modules: {
    impersonateStore,
    tenantStore,
    rosterStore,
    categorySubjectStore,
    partnerDataStore,
  },
});
